import { createActionGroup, props, emptyProps } from '@ngrx/store';
import { IReckonInRoomCredentials } from '@era/locations-sdk';
import { ErrorModel } from '@era/app';

// ============================================================================
// API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const InRoomCredentialsApiActions = createActionGroup({
  source: 'In Room credentials API',
  events: {
    'Credentials loaded': props<{ settings: IReckonInRoomCredentials[] }>(),
    'Credentials loaded error': props<{ error: ErrorModel }>(),
    'Credentials added': props<{ setting: IReckonInRoomCredentials }>(),
    'Credentials added error': props<{ setting: IReckonInRoomCredentials; error: ErrorModel }>(),
    'Credentials updated': props<{ setting: IReckonInRoomCredentials }>(),
    'Credentials updated error': props<{ setting: IReckonInRoomCredentials; error: ErrorModel }>(),
    'Credentials deleted': props<{ setting: IReckonInRoomCredentials }>(),
    'Credentials deleted error': props<{ setting: IReckonInRoomCredentials; error: ErrorModel }>(),
  },
});

// ============================================================================
// VIEW ACTIONS (Group - using createActionGroup)
// ============================================================================

export const InRoomCredentialsViewActions = createActionGroup({
  source: 'In Room credentials view',
  events: {
    'Credentials added': props<{ credentials: IReckonInRoomCredentials }>(),
    'Credentials updated': props<{
      originalCredentials: IReckonInRoomCredentials;
      credentials: IReckonInRoomCredentials;
    }>(),
    'Credentials deleted': props<{ credential: IReckonInRoomCredentials }>(),
  },
});

// ============================================================================
// RESOLVER ACTIONS (Group - using createActionGroup)
// ============================================================================

export const InRoomCredentialsResolverActions = createActionGroup({
  source: 'In Room credentials resolver',
  events: {
    'Credentials requested': emptyProps(),
  },
});
